import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { H5 } from '../../../../AbstractElements';
import { DailyDropdown, Visitors } from '../../../../Constant';
import { OptionsVisitorChartWidget } from '../../../../Data/Ecommerce/Chart';
import SvgIcon from '../../../Common/Component/SvgIcon';
import DropdownCommon from '../../../Common/Dropdown';
import axios from 'axios';
import config from '../../../../config';

const ConversionByDay = ({ propertyId }) => {
const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };
    const concessionaire_id = localStorage.getItem("concessionaireId");
    const [labels, setLabels] = useState(["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]);
    const [thisWeekData, setThisWeekData] = useState([]);
    const [lastWeekData, setLastWeekData] = useState([]);
    const property_access = localStorage.getItem("propertyAccess");
    useEffect(() => {
        const data = {
            concessionaire_id,
            property_id: propertyId,
            property_access:property_access,
            //timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        };

        axios
            .post(`${config.hostname}/trafficdashboard/getweeklyconversioncomparison`, data, configheader)
            .then((response) => {
                setLabels(response.data.labels);
                setThisWeekData(response.data.thisWeekConversion);
                setLastWeekData(response.data.lastWeekConversion);
            })
            .catch((error) => {
                console.error(error);
            });

    }, [propertyId]);

    // get dynamic max value for y-axis
    const getDynamicMax = () => {
        const combined = [...thisWeekData, ...lastWeekData];
        if (combined.length === 0) return 100; // fallback
        const maxVal = Math.max(...combined);
        return Math.ceil(maxVal * 1.1); // add 10% padding
    };

    const OptionsVisitorChartWidget = {
        series: [
            {
                name: "This Week",
                data:thisWeekData,// [54, 10, 25, 18, 28, 10, 51],
            },
            {
                name: "Last Week",
                data: lastWeekData,//[60, 50, 30, 30, 25, 45, 57],
            },
        ],
        options: {
            chart: {
                type: "bar",
                height: 270,
                toolbar: {
                    show: false,
                },
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "50%",
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 6,
                colors: ["transparent"],
            },
            grid: {
                show: true,
                borderColor: "var(--chart-border)",
                xaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            colors: ["#4caaf0", "var(--theme-default)"],
            xaxis: {
                categories:labels,// ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",],
                tickAmount: 4,
                tickPlacement: "between",
                labels: {
                    style: {
                        fontFamily: "Rubik, sans-serif",
                    },
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                min: 0,
                max: getDynamicMax(),
                tickAmount: 5,
                tickPlacement: "between",
                labels: {
                    style: {
                        fontFamily: "Rubik, sans-serif",
                    },
                },
            },
            fill: {
                opacity: 1,
            },
            legend: {
                position: "top",
                horizontalAlign: "left",
                fontFamily: "Rubik, sans-serif",
                fontSize: "14px",
                fontWeight: 500,
                labels: {
                    colors: "var(--chart-text-color)",
                },
                markers: {
                    width: 6,
                    height: 6,
                    radius: 12,
                },
                itemMargin: {
                    horizontal: 10,
                },
            },
            responsive: [
                {
                    breakpoint: 1366,
                    options: {
                        plotOptions: {
                            bar: {
                                columnWidth: "80%",
                            },
                        },
                        grid: {
                            padding: {
                                right: 0,
                            },
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        plotOptions: {
                            bar: {
                                columnWidth: "50%",
                            },
                        },
                        grid: {
                            padding: {
                                right: 0,
                            },
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        plotOptions: {
                            bar: {
                                columnWidth: "60%",
                            },
                        },
                        grid: {
                            padding: {
                                right: 5,
                            },
                        },
                    },
                },
            ],
        },
    };


    return (
        <Card className='visitor-card'>
            <CardHeader className='card-no-border pb-0'>
                <div className='header-top'>
                    <H5 attrH5={{ className: 'm-0' }}>
                        Conversion By week
                        <span className='f-14 font-primary f-w-500 ms-1'>
                            <SvgIcon iconId='user-visitor' className='svg-fill me-1' />
                            {/* (+2.8) */}
                        </span>
                    </H5>
                    <div className='card-header-right-icon'>
                        <DropdownCommon dropdownMain={{ className: 'icon-dropdown', direction: 'start' }} options={DailyDropdown} iconName='icon-more-alt' btn={{ tag: 'span' }} />
                    </div>
                </div>
            </CardHeader>
            <CardBody className='pt-3'>
                <div className='visitors-container'>
                    <ReactApexChart height={270} type='bar' options={OptionsVisitorChartWidget.options} series={OptionsVisitorChartWidget.series} />
                </div>
            </CardBody>
        </Card>
    )
}

export default ConversionByDay